<template>
  <v-container grid-list-lg>
    <v-layout row>
      <v-flex xs12 class="text-center display-1 mt-12">Our Clients</v-flex>
    </v-layout>
    <v-layout row wrap class="mb-12 text-center">
      <v-flex xs12 sm12 md3 class="mb-5">
        <v-avatar color="orange" size="150">
          <span class="white--text subtitle-1">
            TD Niagara Jazz Festival
          </span>
        </v-avatar>
      </v-flex>
      <v-flex xs12 sm12 md3 class="mb-5">
        <v-avatar color="orange" size="150">
          <span class="white--text subtitle-1">
            Dryject Ontario
          </span>
        </v-avatar>
      </v-flex>
      <v-flex xs12 sm12 md3 class="mb-5">
        <v-avatar color="orange" size="150">
          <span class="white--text subtitle-1">
            2525698 Ontario Inc.o/a Tangant
          </span>
        </v-avatar>
      </v-flex>
      <v-flex xs12 sm12 md3 class="mb-5">
        <v-avatar color="orange" size="150">
          <span class="white--text subtitle-1">
            JADE Group
          </span>
        </v-avatar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Clients'
}
</script>

<style scoped>
.headline,
.subtitle-1 {
  word-break: keep-all;
}
</style>
